import {css} from 'lit';
export const styles = css`:host {
  --trigger-height: auto;
  --trigger-border-radius: 16px;
  --trigger-color: var(--contrast-light);
  --trigger-bg: transparent;
  --trigger-hover-color: var(--contrast-light);
  --trigger-hover-bg: transparent;
  --trigger-active-color: var(--contrast-light);
  --trigger-active-bg: var(--primary-700);
}

ef-dot-menu::part(language) {
  --min-width: 0; /* width of the icon */
}

.xs-btn {
  --btn-border-radius: var(--trigger-border-radius);
  --btn-color: var(--trigger-color);
  --btn-bg: var(--trigger-bg);
  --btn-hover-color: var(--trigger-hover-color);
  --btn-hover-bg: var(--trigger-hover-bg);
  --btn-active-color: var(--trigger-active-color);
  --btn-active-bg: var(--trigger-active-bg);

  display: inline-flex;
  align-items: center;
  height: var(--trigger-height);
}

.xs-btn ef-icon {
    font-size: inherit;
    font-size: var(--trigger-icon-font-size, inherit);
  }

.xs-btn span {
    display: inline;
    display: var(--trigger-text-display, inline);
  }
`;
export default styles;
